import { Input } from '@/components/ui/Input';
import { Label } from '@/components/ui/label';
import { cn } from '@/utils/cn';

interface TimeInputProps {
  value?: string | null;
  onChange: (value: string | null) => void;
  label: string;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
}

export function TimeInput({
  value,
  onChange,
  label,
  placeholder = '00:00',
  className,
  disabled = false,
}: TimeInputProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    onChange(val === '' ? null : val);
  };

  return (
    <div className={cn('space-y-2', className)}>
      <Label>{label}</Label>
      <Input
        type="time"
        value={value || ''}
        onChange={handleChange}
        placeholder={placeholder}
        disabled={disabled}
      />
    </div>
  );
}
